import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminUsermanagementComponent } from "./pages/admin-usermanagement/admin-usermanagement.component";
import { AdminWorkstationManagementComponent } from "./pages/admin-workstation-management/admin-workstation-management.component";
import { AdminDashboardComponent } from "./pages/admin-dashboard/admin-dashboard.component";
import { AdminRoutingModule } from "./admin-routing.module";
import { AdminProductionLineManagementComponent } from "./pages/admin-production-line-management/admin-production-line-management.component";
import { ReactiveFormsModule } from "@angular/forms";
import { ProductionLineService } from "./data-access/production-line.service";
import { ProductionLineDetailsPageComponent } from "./pages/admin-production-line-management/production-line-details-page/production-line-details-page.component";
import { ProductionLineFormComponent } from "./pages/admin-production-line-management/production-line-form/production-line-form.component";
import { ProductionLineViewComponent } from "./pages/admin-production-line-management/production-line-view/production-line-view.component";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { WorkstationFormComponent } from "./pages/admin-workstation-management/workstation-form/workstation-form.component";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AdminDashboardComponent,
    AdminUsermanagementComponent,
    AdminWorkstationManagementComponent,
    AdminRoutingModule,
    AdminProductionLineManagementComponent,
    ProductionLineViewComponent,
    ProductionLineFormComponent,
    ProductionLineDetailsPageComponent,
    WorkstationFormComponent,
  ],
  providers: [
    ProductionLineService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "outline" },
    },
  ],
})
export class AdminModule {}
